import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { Fragment } from "react";
import { Pressable } from "react-native";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

export type BreadcrumbType = {
	label: string;
	action?: () => void;
};

type Props = {
	breadcrumbs: BreadcrumbType[];
};

export const CustomBreadcrumb = ({ breadcrumbs }: Props) => {
	const theme = useAppTheme();

	return (
		<Box flexDirection="row" alignItems="center" flexWrap="wrap" gap={4}>
			{breadcrumbs.map(({ label, action }, index) => {
				const isLast = index === breadcrumbs.length - 1;
				const isLastNested = breadcrumbs.length > 1 && isLast;
				return (
					<Fragment key={label}>
						<Pressable
							onPress={action}
							style={{
								cursor: action ? "pointer" : "auto",
								...(isLastNested
									? {
											paddingVertical: 4,
											paddingHorizontal: 8,
											borderRadius: 6,
											backgroundColor: theme.colors.surfaceVariant,
										}
									: {}),
							}}
						>
							<Text
								variant="titleSmall"
								style={{
									color: theme.colors.onSurfaceVariant,
								}}
							>
								{label}
							</Text>
						</Pressable>
						{!isLast && (
							<Icon
								name="slash-forward"
								size={20}
								color={theme.colors.onSurfaceVariant}
							/>
						)}
					</Fragment>
				);
			})}
		</Box>
	);
};
